import { HttpClient, HttpEvent, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CryptService } from '../shared/services/crypt.service';
import { AppConfigService } from '../reactive-forms/services/app-config.service';
import { ErrorDetailsService } from "bi-modules";
import { HttpService } from '../shared/services/HttpClientServices/Http.service';
import { LoginInputModel } from '../login/LoginInputModel';
import { LoginService } from '../login/login.service';
import { AuthTypeEnum } from '../login/login.component';
import { SignalRHelperService } from '../shared/services/SignalRHelper.service';
@Component({
  selector: 'app-select-buform',
  templateUrl: './select-buform.component.html',
  styleUrls: ['../login/login.component.scss']
})
export class SelectBUFormComponent {
  @Input() listItems: any;
  @Input() creds: LoginInputModel;
  @Input() Displayedpassword: string;
  @Output() ReturnToLogin = new EventEmitter();
  public defaultItem: any;
  public imagePath: string;
  public AuthTypeSSO = AuthTypeEnum.SSO;

  constructor(private http: HttpClient,
    private cryptService: CryptService,
    private environment: AppConfigService,
    public errorDetailsService: ErrorDetailsService,
    private loginService: LoginService,
    private _signalrHelper: SignalRHelperService,
    private paramService: HttpService) {

  }
  ngOnInit() {
    if (this.creds.AuthType == this.AuthTypeSSO) {
      this.percentDone = 0;
    }

    this.paramService.get('SA_CompanyImages?Filter=ImageType eq 0 and IsCurrent eq true').subscribe(res => {
      this.imagePath = this.environment.boURL + "/CompanyImagesUploads/" + res?.value[0].ImagePath;
    });
    this.defaultItem = this.listItems[0];
    this.selectionChange(0);
  }
  public selectionChange(value: any): void {
    var index = Number(value);
    this.creds.BusinessUnit = this.listItems[index].BUID;
    this.creds.BusinessUnitName = this.listItems[index].Description;
    this.creds.BusinessUnitAName = this.listItems[index].DescriptionA;
  }

  apiError = null
  async onContinueClick() {
    if (this.creds.AuthType == this.AuthTypeSSO) {
      this.loginService.RegenerateSSOToken(this.creds.ODataToken, this.creds.BusinessUnit, String(this.creds.Language)).subscribe(ssoToken => {
        this.loginService.userData.token = ssoToken.token;
        this.loginService.LoadUserClaims(this.creds, this.defaultItem);
        this.loginService.isLoggedIn = true;
        this.loginService.RedirectToHome();
      });
    }
    else {
      this.creds.Password = this.cryptService.Encrypt(this.Displayedpassword);

      this.loginService.RemoveLocalStorageTokens();

      var body = {
        "Password": this.Displayedpassword,
        "Username": this.creds.Username,
        "lang": (Number(this.creds['Language']) == 1) ? 'ar-EG' : 'en-US',
        "BUID": this.creds.BusinessUnit,
        "Client": this.creds.Client
      }
      if (this.creds.BusinessUnit && this.creds.BusinessUnit != '') {
        var url = this.environment.oDataApi + `/api/Authenticate/login?ADAuth=${this.creds.AuthType}`;
        this.postUnauthorized(url, body).subscribe({
          next: (event) => {
          this.getEventMessage(event, body);
          },
          error: (error) => {
            this.percentDone = 0;
            this.apiError = error.error.error.message.value
          }
       });
      }
    }
  }

  public percentDone = 0;
  private getEventMessage(event: HttpEvent<any>, file: any) {
    switch (event.type) {
      case HttpEventType.Sent:
        this.percentDone = 1;
        return;

      case HttpEventType.UploadProgress:
        this.percentDone = event.total ? Math.round(100 * event.loaded / event.total) : 0;
        return;

      case HttpEventType.Response:
        this.loginService.setLoginClaims(event.body, this.creds, this.defaultItem);
        this._signalrHelper.EstablishConnection();
        this.percentDone = 0;
        this.loginService.isLoggedIn = true;
        this.loginService.RedirectToHome();
        return;

      default:
        return;
    }
  }

  postUnauthorized(url, body): Observable<HttpEvent<any>> {
    return this.http.post(url, body, {
      reportProgress: true,
      observe: "events",
      headers: new HttpHeaders(
        { 'Content-Type': 'application/json' },
      )
    });
  }
  public Return2Login() {
    this.ReturnToLogin.emit();
  }

  UpdateCredsLanguage(language) {
    this.creds.Language = language;
  }
}
